import home from "./home";
import member from "./member";
import errorPage from "./error-page";

//一级挂载的路由
const routes = [
  home,       //首页
  member,       //首页
  errorPage   //错误页
];

export default routes;
